import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { VisualModule } from '~shared/material/visual.module';
import { NaoAutorizadoComponent } from './nao-autorizado.component';


@NgModule({
  declarations: [
    NaoAutorizadoComponent,
  ],
  imports: [
    BrowserModule,
    VisualModule,
  ],
  providers: [
  ],
})
export class NaoAutorizadoModule {
}
